import 'braid-design-system/reset';
import {
  type NormalizedCacheObject,
  type ApolloClient,
  ApolloProvider,
} from '@apollo/client';
import { HygraphInspector } from '@hygraph/live-preview-sdk/react';
import { MelwaysProvider } from '@seek/melways-react';
import { VocabProvider } from '@vocab/react';
import { Box } from 'braid-design-system';
import { Outlet } from 'react-router';

import { CandidateFeatureFlagApolloProvider } from './providers/CandidateFeatureFlagProvider';
import { AuthProvider } from './shared/hooks/useAuth';
import {
  ConfigProvider,
  type ConfigStateContext,
} from './shared/hooks/useConfig';

type Props = {
  client: ApolloClient<NormalizedCacheObject>;
  clientTAL: ApolloClient<NormalizedCacheObject>;
  config: ConfigStateContext;
};

export const Root = ({ config, client, clientTAL }: Props) => (
  <MelwaysProvider.Server url={config.fullURL} site={config.site}>
    <CandidateFeatureFlagApolloProvider config={config}>
      <ApolloProvider client={client}>
        <ConfigProvider config={config}>
          <AuthProvider>
            <VocabProvider language={config.melwaysLocale}>
              {config.hygraphContentApi && (
                <HygraphInspector endpoint={config.hygraphContentApi}>
                  <OutletWrapper
                    config={config}
                    client={client}
                    clientTAL={clientTAL}
                  />
                </HygraphInspector>
              )}
              {!config.hygraphContentApi && (
                <OutletWrapper
                  config={config}
                  client={client}
                  clientTAL={clientTAL}
                />
              )}
            </VocabProvider>
          </AuthProvider>
        </ConfigProvider>
      </ApolloProvider>
    </CandidateFeatureFlagApolloProvider>
  </MelwaysProvider.Server>
);

const OutletWrapper = ({ config, client, clientTAL }: Props) => (
  <Box role="main">
    <Outlet context={{ config, client, clientTAL }} />
  </Box>
);
